module.exports = __webpack_public_path__ + "img/grenade-damage.012ad8a7.png";